<template>
  <div class="mt-4 py-1 box-border notranslate">
    <div v-for="largeCl in largeClassificationList" :key="largeCl.id" class="pb-6">
      <p class="my-2">
        <span class="text-2xl font-bold mr-4 notranslate">
          {{ largeCl.id }}
        </span>
        <span class="text-base notranslate">{{ largeCl.title }}</span>
      </p>
      <div class="grid grid-cols-3 gap-4">
        <base-challenge-card
          v-for="middleCl in largeCl.middleCls"
          :key="middleCl.id"
          :middleCl="middleCl"
          :onClick="() => onClickMiddleCl(largeCl.id, middleCl.id)"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import BaseChallengeCard from './BaseChallengeCard.vue'

import { useChallengePresenter } from '@/presentation/composables/problem/useChallengePresenter'

export default defineComponent({
  components: {
    BaseChallengeCard
  },
  props: {
    onClickMiddleCl: {
      type: Function,
      required: true
    }
  },
  setup(props) {
    const challengePresenter = useChallengePresenter()

    return {
      largeClassificationList: challengePresenter.largeClassificationList
    }
  }
})
</script>

<style></style>
